<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Ekip İşlemleri</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="info" @click="SayfaYukle" :disabled="lo">yenile</el-button>
        <el-button size="small" type="primary" @click="BolgeEkle" :disabled="lo">Ekip Ekle</el-button>
      </div>
    </div>
    <div class="SayfaIcerik SayfaTable" v-loading="lo">
      <el-table
          v-if="Liste"
          class="table-xs table-hover"
          :data="Liste.filter(data => !Kelime || data.adi.toLowerCase().includes(Kelime.toLowerCase()))"

          :height="Height">
        <el-table-column label="#" prop="id" width="75"></el-table-column>
        <el-table-column label="Ekip Adı" prop="adi"></el-table-column>
        <el-table-column
            align="right" label="Bakim" prop="Grup" width="250" class-name="tablearama">
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">Düzenle
            </el-button>

            <el-button
                size="mini"
                @click="handleDelete(scope.$index, scope.row)">Sil
            </el-button>
          </template>

          <template slot="header" slot-scope="scope">
            <el-input
                v-model="Kelime"
                size="mini"
                class="tablearamainput"
                placeholder="Arama Yapın"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <Modal :Bilgi="Bilgi" :Tur="Tur" :Durum="ModalDurum" @Durum="SayfaYukle"></Modal>
  </div>
</template>

<script>
import Modal from "./Comp/Modal";

export default {
  components: {Modal},
  data() {
    return {
      lo: false,
      ModalDurum: false,
      Tur: null,
      Kelime: "",
      Height: null,
      Bilgi: null,
      Liste: null
    }
  },
  methods: {
    TableSecim(e) {
      //this.$router.push('/ekip/' + e.id)
      //this.Bilgi
    },
    SayfaYukle() {
      this.lo = true
      this.ModalDurum = false
      this.$store.dispatch("Get", {path: 'ekip'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Liste = response.Data
              this.lo = false
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    handleEdit(index, row) {
      this.Tur = 'Put'
      this.Bilgi = row
      this.ModalDurum = true
      this.$forceUpdate()

    },
    handleDelete(index, row) {
      this.$store.dispatch("Delete", {path: 'ekip/' + row.id})
          .then(response => {
            if (response.Durum === "OK") {
              this.$notify.info({
                title: response.Mesaj,
                customClass: 'info'
              });
              this.DetayModalDurum = false
              this.SayfaYukle()
            } else {
              this.$notify.error({
                title: response.Mesaj,
                customClass: 'error'
              });
              this.lo = false
            }
          })
    },
    BolgeEkle() {
      this.ModalDurum = true
      this.Bilgi = {};
      this.Tur = 'Post'

    }
  },
  created() {
    this.$store.dispatch("title", "Ekip İşlemleri");
    this.SayfaYukle();
    this.Height = window.innerHeight - 111
  },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ekip/liste.vue